<template>
    <div>
        <el-input type="text" v-model="input" :placeholder="`${config.placeholder}`" clearable>
        </el-input>
    </div>
</template>

<script>
export default {
    name: 'FromInput',
    components: {},
    props: {
        value: {
            type: String,
            default: ''
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        input(value) {
            this.$emit('change', value)
        },
        value(value) {
            this.input = value
        }
    },
    data() {
        return {
            input: this.value
        }
    },
    methods: {

    }
}
</script>
